import React from "react";

const TvbetIcon = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="60"
			height="16"
			viewBox="0 0 60 16"
			fill="none"
			{...props}>
			<mask
				id="mask0_2030_79006"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="60"
				height="16">
				<path
					d="M59.8356 0.759766H0V15.2028H59.8356V0.759766Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_2030_79006)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M46.3751 6.13909V15.2036H43.9414V6.13909H41.6587L40.6914 4.03906H49.6251V6.13909H46.3751Z"
					fill="white"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M34.6007 6.13909V8.49042H39.1716V10.5904H34.6007V13.1035H39.9165L39.9333 15.2036H32.1641V4.03906H39.1716L40.139 6.13909H34.6007Z"
					fill="white"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M24.3664 10.4373V13.1035H26.5891C27.4136 13.1035 28.1241 12.6674 28.1241 11.7719C28.1241 10.8764 27.425 10.4373 26.6033 10.4373H24.3664ZM24.3664 8.51353H26.1553C26.8915 8.51353 27.5449 8.13512 27.5449 7.32631C27.5449 6.5175 26.9086 6.13909 26.1696 6.13909H24.3664V8.51353ZM28.9315 9.25013C29.4413 9.4601 29.8769 9.82015 30.1821 10.2837C30.4874 10.7472 30.6481 11.2928 30.6435 11.8499C30.6435 14.0308 28.9316 15.2093 26.9029 15.2093H21.9297V4.03906H26.8487C28.6919 4.03906 30.0529 5.19451 30.0529 7.10678C30.0529 7.53082 29.9495 7.94829 29.7519 8.3222C29.5543 8.69606 29.2686 9.01481 28.9201 9.25013H28.9315Z"
					fill="white"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.68655 6.13909V15.2036H3.24986V6.13909H0V4.03906H7.96628L8.93352 6.13909H5.68655Z"
					fill="white"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.9767 4.03906H20.4105L15.269 15.2036H14.6327L9.48828 4.03906H11.925L14.9494 10.6078L17.9767 4.03906Z"
					fill="white"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M53.7735 3.64648H51.6992L53.0287 6.53221H55.103L53.7735 3.64648Z"
					fill="white"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M58.5096 3.64549L57.1798 6.53122H55.1055L56.4353 3.64549L57.762 0.759766H59.839L58.5096 3.64549Z"
					fill="white"
				/>
			</g>
		</svg>
	);
};

export default TvbetIcon;
